import script from "./ExpenseLists.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseLists.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseLists.vue?vue&type=style&index=0&id=79b7be2f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b7be2f"]])

export default __exports__